<template>
  <v-container grid-list-xl fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs fluid style="padding: 0px">
        <v-layout row style="padding: 0px">
          <!-- Dialog for Add View Edit -->

          <v-flex md6>
            <v-form ref="form">
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search by Card No."
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-form>
          </v-flex>

          <v-spacer></v-spacer>
          <v-btn fab dark small color="amber darken-2" @click="getData">
            <v-icon dark>play_arrow</v-icon>
          </v-btn>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="refreshData()"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="$moduleAccess('download excel')"
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadExcel"
            >
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="$moduleAccess('download pdf')"
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadPDF"
            >
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M10.1,11.4C10.08,11.44 9.81,13.16 8,16.09C8,16.09 4.5,17.91 5.33,19.27C6,20.35 7.65,19.23 9.07,16.59C9.07,16.59 10.89,15.95 13.31,15.77C13.31,15.77 17.17,17.5 17.7,15.66C18.22,13.8 14.64,14.22 14,14.41C14,14.41 12,13.06 11.5,11.2C11.5,11.2 12.64,7.25 10.89,7.3C9.14,7.35 9.8,10.43 10.1,11.4M10.91,12.44C10.94,12.45 11.38,13.65 12.8,14.9C12.8,14.9 10.47,15.36 9.41,15.8C9.41,15.8 10.41,14.07 10.91,12.44M14.84,15.16C15.42,15 17.17,15.31 17.1,15.64C17.04,15.97 14.84,15.16 14.84,15.16M7.77,17C7.24,18.24 6.33,19 6.1,19C5.87,19 6.8,17.4 7.77,17M10.91,10.07C10.91,10 10.55,7.87 10.91,7.92C11.45,8 10.91,10 10.91,10.07Z"
                />
              </svg>
            </v-btn>
            <span>Download PDF File</span>
          </v-tooltip>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="dateFromMenu"
                :close-on-content-click="false"
                v-model="dateFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFrom"
                  label="Date"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="dateFromMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="timeFromMenu"
                :close-on-content-click="false"
                v-model="timeFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeFrom"
                  @click="clockMode = 'timeFrom'"
                  label="Time From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-time-picker v-model="timeFrom" format="24hr">
                  <v-btn flat color="amber" @click="cancelTimePicker">Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat color="amber" @click="timeFromMenu = false;">DONE</v-btn>
                </v-time-picker>
              </v-menu>
            </v-flex>-->
            <!-- 
            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="dateToMenu"
                :close-on-content-click="false"
                v-model="dateToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateTo"
                  label="Date To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateTo"
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="dateFrom"
                  @input="dateToMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex> -->

            <!-- <v-flex md2 style="padding: 5px 0px 0px 5px;">
              <v-combobox
                v-model="filterDiscrepancyType"
                :items="filterDiscrepancyTypes"
                label="Discrepancy Type"
                dense
                outlined
                solo
                clearable
              ></v-combobox>
            </v-flex> -->
            <!-- 
            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="timeToMenu"
                :close-on-content-click="false"
                v-model="timeToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"0
                  v-model="timeTo"
                  @click="clockMode = 'timeTo'"
                  label="Time To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>
                <v-time-picker v-model="timeTo" format="24hr">
                  <v-btn flat color="amber" @click="cancelTimePicker">Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat color="amber" @click="timeToMenu = false;">DONE</v-btn>
                </v-time-picker>
              </v-menu>
            </v-flex>-->
          </v-layout>
        </v-container>
      </v-container>

      <!-- <v-container fluid class="pa-2">
        <v-layout row>
          <v-flex sm4 md4 class="pl-0">
            <v-btn @click="openFilterExpansion">
              <v-icon class="mr-3">{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
              <span>Filter {{ title }}</span>
            </v-btn>
          </v-flex>
          <v-flex sm8 md8></v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider> -->
      
      <!-- <filter-panel :openFilter="openFilter">
        <v-flex md4>
          <v-select
            v-model="filterWirelessTransaction"
            :items="filterWirelessTransactions"
            label="Transaction Type"
            solo
            clearable
          ></v-select>
        </v-flex>
      </filter-panel> -->

      <action-dialog
        :type="dialogType"
        :title="title"
        :dialog="dialogStatus"
        @saveDialog="saveDialog"
        @closeDialog="closeDialog"
        :loading="dialogLoading"
      >
        <v-container grid-list-xs>
          <v-layout justify-center>
            <v-flex md12>
              <!-- Insert View Dialog Content BELOW-->
              <details-container
                ref="detailsRef"
                :data="viewData"
                :items="computedItems"
                :headers="transactionHeaders"
                @save="addTransaction"
                :readOnly="dialogType === 'view'"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </action-dialog>

      <confirm-dialog
        :confirmDialog="openConfirmDialog"
        @saveConfirmDialog="saveTransactionDialog"
        @closeConfirmDialog="closeConfirmDialog"
        :loading="confirmLoading" 
      ></confirm-dialog>

      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        disable-initial-sort
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                header.value === queryParams.order ? 'active' : '',
                'text-xs-' + header.align,
              ]"
            >
              <span>{{ header.text }}</span>
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.card_no }}</td>
          <td class="text-xs-center">
            {{
              props.item.datetime_from
                ? $dateFormat(props.item.datetime_from, "YYYY-MM-DD")
                : "--"
            }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.datetime_from
                ? $dateFormat(props.item.datetime_from, "HH:mm")
                : "--"
            }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.datetime_to
                ? $dateFormat(props.item.datetime_to, "YYYY-MM-DD")
                : "--"
            }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.datetime_to
                ? $dateFormat(props.item.datetime_to, "HH:mm")
                : "--"
            }}
          </td>
          <td class="text-xs-left text-uppercase">
            {{ props.item.type ? props.item.type : "--" }}
          </td>

          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.discrepancy }}</td>
          <td class="text-xs-right">
            {{
              props.item.all_discrepancy_types
                ? props.item.all_discrepancy_types.toUpperCase()
                : "--"
            }}
          </td>
          <td class="text-xs-right">
            {{
              props.item.total_reload_amount
                ? $amountInPeso(props.item.total_reload_amount)
                : "0.00"
            }}
          </td>

          <td class="text-no-wrap text-xs-center">
            <v-tooltip top>
              <v-btn
                style="height: 16px; width: 15px"
                icon
                slot="activator"
                @click="openViewDialog(props.item)"
              >
                <v-icon color="blue">find_in_page</v-icon>
              </v-btn>
              <span>View</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import OfficialMap from "@/components/OfficialMap";
import XLSX from "xlsx";
import JsPdf from "jspdf";
import "jspdf-autotable";
import DetailsContainer from "@/components/details_container/CardExceptionContainer";
import moment from "moment";

export default {
  components: {
    DetailsContainer,
    OfficialMap,
  },
  data() {
    return {
      clockMode: "",
      openFilter: false,
      timeOut: null,
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      dateFrom: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      dateTo: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      heightMap: "",
      widthMap: "",
      mapDialog: false,
      center: { lat: 14.4793, lng: 121.0198 },
      zoom: 20,
      title: "Transaction Wireless",
      items: [],
      // filterDiscrepancyTypes: [],
      // filterDiscrepancyType: "",
      headers: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Card No.",
          align: "left",
          value: "merchant_code",
          sortable: false,
        },
        {
          text: "Date From",
          align: "center",
          value: "transaction_date",
          sortable: true,
        },
        {
          text: "Time From",
          align: "center",
          value: "transaction_date",
          sortable: true,
        },
        {
          text: "Date To",
          align: "center",
          value: "transaction_date",
          sortable: true,
        },
        {
          text: "Time To",
          align: "center",
          value: "transaction_date",
          sortable: true,
        },
        {
          text: "Last Transaction",
          align: "left",
          value: "transaction_type_id",
          sortable: false,
        },
        {
          text: "Count",
          align: "right",
          value: "previous_balance",
          sortable: false,
        },
        {
          text: "Discrepancy",
          align: "right",
          value: "previous_balance",
          sortable: false,
        },
        {
          text: "Discrepancy Type",
          align: "right",
          value: "discrepancy_type",
          sortable: false,
        },
        {
          text: "Amount",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
      transactionHeaders: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Card No.",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Date",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Time",
          align: "left",
          value: "code",
          sortable: false,
        },
        {
          text: "Transaction Type",
          align: "left",
          value: "province",
          sortable: false,
        },
        {
          text: "Previous Balance",
          align: "right",
          value: "province",
          sortable: false,
        },
        {
          text: "Amount",
          align: "right",
          value: "province",
          sortable: false,
        },
        {
          text: "Remaining Balance",
          align: "right",
          value: "province",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],
      filterWirelessTransactions: [],
      filterWirelessTransaction: null,
      queryParams: {
        search: null,
        offset: 0,
        date_from: null,
        date_to: null,
        discrepancy_type: null,
      },
      totalItems: 0,
      show: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewData: {},
      viewItems: [],

      openConfirmDialog: false,
      confirmLoading: false,
      transactionData: null,
      transDataParams: null,
      test: null,
    };
  },
  beforeDestroy() {
    window.stop();
  },
  watch: {},
  created: async function() {
    await this.$store.commit("initiateTempData");
    // await this.setDiscrepancyTypeFilter();
    // await this.getData(true);
  },
  computed: {
    computedItems() {
      return this.$store.state.tempData;
    },
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
  },
  methods: {
    // // async setDiscrepancyTypeFilter() {
    // //   let cardTransTypes = [];
    // //   try {
    // //     this.$store.dispatch("startLoading");
    // //     // Get all data from transaction type service.
    // //     cardTransTypes = await Services.getTransactionTypes({});
    //      Set all the items for the filter
    //     if (cardTransTypes.data.data) {
    //       cardTransTypes.data.data.map((item, i) => {
    //         this.filterDiscrepancyTypes.push({
    //           text: item.name.toUpperCase(),
    //           value: item.name.toLowerCase(),
    //         });
    //         if (i + 1 === cardTransTypes.data.data.length) {
    //           this.filterDiscrepancyTypes.unshift({
    //             text: "RELOAD",
    //             value: "reload",
    //           });
    //         }
    //       });
    //     }
    // //   } catch (error) {
    // //     this.$infoBar({
    // //       type: "error",
    // //       text: "No network or server connection",
    // //     });
    // //   }
    // //   this.$store.dispatch("endLoading");
    // // },
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
    },
    async getData(reset) {
      this.$store.dispatch("startLoading");

      // if (!this.filterDiscrepancyType) {
      //   this.queryParams.discrepancy_type = "";
      // } else if (this.filterDiscrepancyType) {
      //   this.queryParams.discrepancy_type = this.filterDiscrepancyType.value;
      // }
      this.queryParams.date_from = this.dateFrom + " " + this.timeFrom + ":00";
      this.queryParams.date_to = this.dateFrom + " " + this.timeFrom + ":59";

      if (reset) {
        this.queryParams.offset = 0;
        await this.$store.commit("initiateTempData");
      }


      try {
        const response = (await Services.getCardExceptions(this.queryParams))
          .data;
          
      

        this.items = response.data;
      } catch (error) {
        console.log(error)
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }

      this.$store.dispatch("endLoading");
    },
    async setData(data) {
      let value = null;

      try {

        const response = (await Services.getCardException(data)).data;
      
        if (response) {
          this.viewData = response.data;
          this.viewItems = response.transactions;

          await this.$store.dispatch("dispatchTempData", response.transactions);
        }

        this.viewData = response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      return value;
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      await this.setData(data);

      this.transDataParams = data;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },

    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
    },

    async initMap(data) {
      this.heightMap = 80;
      this.widthMap = 87.5;
      this.center = { lat: data.lat, lng: data.long };
      await this.$refs.map.initializeMap();
      await this.$refs.map.addMarker(data);
    },
    refreshData() {
      this.dateFrom = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.$refs.form.reset();
      this.filterWirelessTransaction = null;
      this.getData(true);
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
    openDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewItems = [];

      this.viewItems.push(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    saveDialog() {
      // Condition Form Required Form Validation
      // if (this.$refs.detailsRef.validateForm()) {
      this.openConfirmDialog = true;
      // }
    },
    closeDialog() {
      this.dialogType = "";
      this.dialogStatus = false;
    },
    async downloadExcel() {
      this.$store.dispatch("startLoading");

      this.items = [];

      const response2 = (await Services.getTransactionWireless({
        offset: 0,
        transaction_type_id: null,
        date_from: this.dateFrom + " " + this.timeFrom + ":00",
        date_to: this.dateFrom + " " + this.timeTo + ":59",
      })).data;

      this.items = response2.data;

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }
      header.shift();
      header.pop();
      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];

        theItem.push(this.items[e].sub_company.code);
        theItem.push(
          this.items[e].card_shift_wireless === null
            ? ""
            : this.items[e].card_shift_wireless.control_no
        );
        theItem.push(this.items[e].device.device_serial);
        theItem.push(this.items[e].terminal.name.toUpperCase());
        theItem.push(
          this.$dateFormat(this.items[e].transaction_date, "YYYY-MM-DD")
        );
        theItem.push(this.$dateFormat(this.items[e].transaction_date, "HH:mm"));
        theItem.push(this.items[e].transaction_no);
        theItem.push(this.items[e].trace_no);
        theItem.push(this.items[e].card_no);
        theItem.push(this.items[e].transaction_type.name.toUpperCase());
        theItem.push(this.items[e].previous_balance);
        theItem.push(this.items[e].card_amount);
        theItem.push(this.items[e].remaining_balance);
        theItem.push(
          this.items[e].user
            ? `${this.items[e].user.first_name} ${this.items[e].user.middle_name} ${this.items[e].user.last_name}`
            : ""
        );

        dataToDownload.push(theItem);
      }

      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    addTransaction(data) {
      this.openConfirmDialog = true;

      this.transactionData = data;
    },
    async saveTransactionDialog() {
      this.confirmLoading = true;

      const { data, index } = this.transactionData;

      let body = {
        card_no: data.card_no,
        transaction_date: moment(data.datetime).format("YYYY-MM-DD HH:mm:ss"),
        previous_balance: data.previous_balance,
        amount: data.amount,
        remaining_balance: data.remaining_balance,
        previous_transaction_id: data.previous_transaction_id,
        transaction_type: data.type,
      };

      try {
        const response = await Services.addMissingTransaction(body);

        const insertedData = response.data;

        if (response.status === 201 || response.status === 204) {
          // this.$store.dispatch("editTempDataItems", {
          //   index,
          //   item: {
          //     amount: insertedData.amount,
          //     card_no: insertedData.card_no,
          //     datetime: moment(insertedData.transaction_date).format(
          //       "YYYY-MM-DD HH:mm:ss"
          //     ),
          //     previous_balance: insertedData.previous_balance,
          //     previous_transaction_id: insertedData.previous_transaction_id,
          //     remaining_balance: insertedData.remaining_balance,
          //     status: 2,
          //     transaction_id: insertedData.id,
          //     type: insertedData.transaction_type,
          //   },
          // });

          await this.setData(this.transDataParams);

          this.$infoBar({
            type: "success",
            text: "Transaction has been saved!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      this.confirmLoading = false;
      this.closeConfirmDialog();
    },

    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async downloadPDF() {
      this.$store.dispatch("startLoading");

      this.items = [];

      const response2 = (await Services.getTransactionWireless({
        offset: 0,
        transaction_type_id: null,
        date_from: this.dateFrom + " " + this.timeFrom + ":00",
        date_to: this.dateTo + " " + this.timeTo + ":59",
      })).data;

      this.items = response2.data;

      var doc = new JsPdf("l", "pt", "a4");

      doc.setFontSize(15);
      doc.setFontType("bold");
      doc.text(this.title + " Report", 410, 30, { align: "center" });

      let headers = [
        [
          "Card No.",
          "Date From.",
          "Time From",
          "Date To",
          "Time To",
          "Last Transaction",
          "Count",
          "Discrepancy",
          "Discrepancy Type",
          "Amount",
          "Action ",
        ],
      ];

      let data = [];

      this.items.forEach((item) => {
        let theData = [
          item.sub_company.code,
          item.card_shift_wireless === null
            ? ""
            : item.card_shift_wireless.control_no,
          item.device.device_serial,
          item.terminal.name.toUpperCase(),
          this.$dateFormat(item.transaction_date, "YYYY-MM-DD"),
          this.$dateFormat(item.transaction_date, "HH:mm"),
          item.transaction_no,
          item.trace_no,
          item.card_no,
          item.transaction_type.name.toUpperCase(),
          this.numberWithCommas(item.previous_balance.toFixed(2)),
          this.numberWithCommas(item.card_amount.toFixed(2)),
          this.numberWithCommas(item.remaining_balance.toFixed(2)),
          (item.user.first_name === undefined || item.user.first_name === null
            ? ""
            : item.user.first_name) +
            " " +
            (item.user.middle_name === undefined ||
            item.user.middle_name === null
              ? ""
              : item.user.middle_name) +
            " " +
            (item.user.last_name === undefined || item.user.last_name === null
              ? ""
              : item.user.last_name),
        ];
        data.push(theData);
      });

      doc.autoTable({
        didParseCell: (data) => {
          let col = data.column.index;
          if (
            col === 3 ||
            col === 4 ||
            col === 8 ||
            col === "3" ||
            col === "4" ||
            col === "8"
          ) {
            data.table.styles.headStyles.halign = "center";
          } else if (
            col === 9 ||
            col === 10 ||
            col === 11 ||
            col === "9" ||
            col === "10" ||
            col === "11"
          ) {
            data.table.styles.headStyles.halign = "right";
          } else {
            data.table.styles.headStyles.halign = "left";
          }
        },
        head: headers,
        body: data,
        startY: 60,
        margin: {
          left: 10,
        },
        theme: "grid",
        tableWidth: 832,
        cellWidth: "wrap",
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 1,
        },
        showHead: "everyPage",
        tableLineColor: 200,
        tableLineWidth: 0,
        columnStyles: {
          0: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          1: { cellWidth: "auto", lineColor: "black", textColor: [0, 0, 0] },
          2: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          3: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          4: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "center",
          },
          5: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "center",
          },
          6: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          7: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          8: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          9: {
            cellWidth: "auto",
            lineColor: "black",
            halign: "center",
            textColor: [0, 0, 0],
          },
          10: {
            cellWidth: "auto",
            halign: "right",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          11: {
            cellWidth: "auto",
            halign: "right",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          12: {
            cellWidth: "auto",
            lineColor: "black",
            halign: "right",
            textColor: [0, 0, 0],
          },
          13: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
        },
        styles: {
          overflow: "linebreak",
          cellWidth: "wrap",
          fontSize: 7,
        },
      });

      let pageCount = doc.internal.getNumberOfPages();
      for (let i = 0; i < pageCount; i++) {
        doc.setFontType("normal");
        doc.setFontSize(10);
        doc.setPage(i);
        doc.text(
          395,
          580,
          "Page" +
            " " +
            doc.internal.getCurrentPageInfo().pageNumber +
            " " +
            "of" +
            " " +
            pageCount
        );
      }
      doc.save(this.title + ".pdf");

      this.$store.dispatch("endLoading");
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
#viewTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#viewTable td,
#viewTable th {
  border: 2px solid #000;
  padding: 8px;
}

.propertyName {
  background-color: rgb(241, 241, 241);
  font-weight: bold;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.form {
  padding: 0px 5px 10px 5px;
  border: 2px solid gray;
  border-radius: 5px;
}
.form:hover {
  border: 2px solid black;
}
#styled-input {
  height: 10px !important;
  font-size: 10pt !important;
}
</style>
